import {styled} from '@esgi/ui/theme';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export const DropdownMenuContent = styled(DropdownMenu.Content);
